function checkForUntouchedFields(state, dispatch) {
  const untouchedFields = Object.keys(state).filter(
    field => !state[field].touched
  );

  untouchedFields.map(field => dispatch({ type: 'addError', name: field }));

  return untouchedFields;
}

export default checkForUntouchedFields;
